import * as React from "react";
const SvgCookies = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_10886_21123)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.8375 8.5125L14.775 1.5375C13.875 1.3125 12.975 0.75 12 0.75C11.025 0.75 10.125 1.3125 9.1875 1.575C8.25 1.8 7.2 1.7625 6.375 2.25C5.55 2.7375 5.025 3.675 4.35 4.35C3.675 5.025 2.7375 5.55 2.25 6.375C1.7625 7.2 1.8 8.25 1.5375 9.1875C1.3125 10.125 0.75 11.025 0.75 12C0.75 12.975 1.3125 13.875 1.575 14.8125C1.8 15.75 1.7625 16.8 2.25 17.625C2.7375 18.45 3.675 18.975 4.35 19.65C5.025 20.325 5.5125 21.2625 6.375 21.75C7.2 22.2375 8.25 22.2 9.1875 22.4625C10.125 22.6875 11.025 23.25 12 23.25C12.975 23.25 13.875 22.6875 14.8125 22.425C15.75 22.1625 16.8 22.2 17.625 21.7125C18.45 21.225 18.975 20.2875 19.65 19.6125C20.325 18.9375 21.2625 18.45 21.75 17.5875C22.2375 16.7625 22.2 15.7125 22.4625 14.775C22.6875 13.875 23.25 12.975 23.25 12C23.25 11.025 22.4625 8.9625 22.4625 8.9625L13.8375 8.5125Z",
      fill: "#DDA85F"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M22.2749 8.4C21.8999 8.5125 21.3749 8.475 20.8124 8.25C20.0249 7.95 19.5374 7.3125 19.3874 6.5625C19.0124 6.675 18.1124 6.5625 17.5124 6.1875C16.6124 5.625 16.4249 4.05 16.4249 4.05C15.4124 3.75 14.6624 2.55 14.7749 1.5375C13.9499 1.3125 12.8999 1.35 11.9999 1.35C11.0999 1.35 10.2749 1.875 9.44985 2.1C8.58735 2.325 7.61235 2.2875 6.86235 2.7375C6.11235 3.1875 5.62485 4.05 5.02485 4.65C4.38735 5.2875 3.52485 5.7375 3.11235 6.4875C2.66235 7.2375 2.69985 8.2125 2.47485 9.075C2.24985 9.9 1.72485 10.725 1.72485 11.625C1.72485 12.525 2.24985 13.35 2.47485 14.175C2.69985 15.0375 2.66235 16.0125 3.11235 16.7625C3.56235 17.5125 4.42485 18 5.02485 18.6C5.66235 19.2375 6.11235 20.1 6.86235 20.5125C7.61235 20.9625 8.58735 20.925 9.44985 21.15C10.2749 21.375 11.0999 21.9 11.9999 21.9C12.8999 21.9 13.7249 21.375 14.5499 21.15C15.4124 20.925 16.3874 20.9625 17.1374 20.5125C17.8874 20.0625 18.3749 19.2 18.9749 18.6C19.6124 17.9625 20.4749 17.5125 20.8874 16.7625C21.3374 16.0125 21.2999 15.0375 21.5249 14.175C21.7499 13.35 22.6499 12.675 22.7624 11.775C23.0624 10.3125 22.3124 8.6625 22.2749 8.4Z",
      fill: "#F2CB7D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.7877 4.04996L18.2627 4.57496L17.7752 4.04996L18.2627 3.56246L18.7877 4.04996ZM20.9252 6.67496L20.7002 6.93746L20.4377 6.67496L20.7002 6.41246L20.9252 6.67496ZM19.0502 4.94996L18.7877 5.21246L18.5252 4.94996L18.7877 4.68746L19.0502 4.94996ZM16.7252 2.66246L16.4627 2.92496L16.2002 2.66246L16.4627 2.39996L16.7252 2.66246ZM21.4502 7.61246L21.1877 7.87496L20.9252 7.61246L21.1877 7.34996L21.4502 7.61246ZM21.6752 6.67496L21.4127 6.93746L21.1502 6.67496L21.4127 6.41246L21.6752 6.67496Z",
      fill: "#DDA85F"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.42503 7.72496C4.05003 8.36246 4.61253 9.52496 5.36253 9.86246C6.45003 10.3125 7.08753 10.3875 7.76253 9.22496C7.98753 8.81246 8.28753 7.72496 8.17503 7.46246C8.02503 7.08746 7.38753 6.33746 6.97503 6.33746C5.81253 6.37496 4.68753 7.27496 4.42503 7.72496Z",
      fill: "#6D4934"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.61243 7.72496C4.34993 8.17496 5.02493 9.52496 5.92493 9.41246C7.16243 9.26246 7.04993 6.71246 6.52493 6.71246C5.62493 6.71246 4.79993 7.38746 4.61243 7.72496Z",
      fill: "#A37F6A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.9499 14.6626C17.4749 14.5126 17.8499 13.5751 17.6249 13.0126C17.2874 12.1501 16.9499 11.7751 15.9749 12.0376C15.6374 12.1501 14.8499 12.5626 14.7749 12.7501C14.6624 13.0501 14.5874 13.8001 14.8124 14.0251C15.4499 14.6626 16.5749 14.7751 16.9499 14.6626Z",
      fill: "#6D4934"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.4248 13.7626C16.8373 13.6501 17.4748 12.3751 16.7998 12.3001C15.6373 12.1126 14.7373 12.6751 14.8498 13.3126C14.9623 13.9501 16.1248 13.8376 16.4248 13.7626Z",
      fill: "#A37F6A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.33737 16.6875C9.22487 16.2375 8.39987 15.9 7.87487 16.125C7.12487 16.425 6.78737 16.6875 7.04987 17.55C7.12487 17.85 7.49987 18.525 7.68737 18.5625C7.94987 18.675 8.58737 18.7125 8.77487 18.525C9.33737 18 9.41237 17.025 9.33737 16.6875Z",
      fill: "#6D4934"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.70001 16.3501C8.62501 16.0126 7.05001 16.5001 7.20001 17.1001C7.50001 18.1126 7.50001 18.2626 7.80001 18.2251C8.36251 18.0751 8.73751 16.6126 8.70001 16.3501Z",
      fill: "#A37F6A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.1624 9.56252C18.7124 9.67502 18.3749 10.5 18.5999 11.025C18.8999 11.775 19.6124 11.8875 20.3999 11.475C21.0749 11.1375 21.1124 9.93752 20.9249 9.71252C20.3624 9.15002 19.4999 9.48752 19.1624 9.56252Z",
      fill: "#6D4934"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.9749 9.97493C18.7499 10.2374 18.5624 11.2874 19.1249 11.1374C20.1374 10.8374 20.8499 9.82493 20.3999 9.67492C19.8374 9.48742 19.2374 9.67493 18.9749 9.97493Z",
      fill: "#A37F6A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.52759 6.04194L9.27009 5.29944L10.0126 6.04194L9.27009 6.78444L8.52759 6.04194Z",
      fill: "#6D4934"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.51465 12.5562L6.25677 11.8137L6.99927 12.5558L6.25715 13.2983L5.51465 12.5562ZM13.0116 16.8042L13.7541 16.0617L14.4966 16.8042L13.7541 17.5467L13.0116 16.8042ZM12.0141 14.7334L13.0218 13.7258L14.0294 14.7334L13.0218 15.7411L12.0141 14.7334ZM9.2609 3.68518L10.2685 2.67755L11.2761 3.68518L10.2685 4.6928L9.2609 3.68518Z",
      fill: "#DDA85F"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.4205 17.3801L16.163 16.6376L16.9055 17.3801L16.163 18.1226L15.4205 17.3801ZM18.4032 13.2056L19.1457 12.4631L19.8882 13.2056L19.1457 13.9481L18.4032 13.2056ZM15.6792 9.23886L16.0505 8.86761L16.4217 9.23886L16.0505 9.61012L15.6792 9.23886ZM5.14697 14.3497L5.51822 13.9785L5.88947 14.3497L5.51822 14.721L5.14697 14.3497Z",
      fill: "#6D4934"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_10886_21123" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" })))
);
export default SvgCookies;
